// Test IDs for the home / landing feature.

export const HOME = {
        langToggle: 'lang-toggle',
        navWhatsapp: 'nav-whatsapp-btn',
        heroWhatsapp: 'hero-whatsapp-btn',
        heroServices: 'hero-services-btn',
        contactWhatsapp: 'contact-whatsapp-btn',
        instagramLink: 'instagram-link',
        navServices: 'nav-services-link',
        navAbout: 'nav-about-link',
        navContact: 'nav-contact-link',
};
